import { setLocaleData, setNewsData, setProducts } from '../actions/load';
import { setSelectedAssetTab } from '../actions/settings';
import makeApiRequest from '../utils/makeApiRequest';
import makeOrCacheApiReq from '../utils/apiCache';
import { getHostName } from '../utils/urlUtils';
import { readCookie } from '../utils/cookies-browser';
import metaInfo from '../config/metaInfo';
import API_PATH from '../actions/actionsFactory/apiPath';
import { gwGet } from '../actions/actionsFactory/gwRequest';
import { handleGwData } from '../actions/actionsFactory';
import {
  fetchNotice,
  getRecommendsRequest,
} from '../actions/actionsSet/market';

import { setPublicAssetsStatus } from '../actions/actionsSet/userConfig';
import { wssUri } from './handleInitTask';
import { checkMobile } from '../utils/redirectToMobileSite.mjs';

const {
  brands, metaTitles, metaKeywords, metaDescriptions,
} = metaInfo;

const I18N_API_PATH = (isServer, locale) => isServer ?
  `http://localhost:${process.env.PORT || 3000}/en/i18n/${locale}.json` : `/en/i18n/${locale}.json`;

// !!! only ONE `await` allowed in this code !!!

export default async ({
  isServer, req, query, store,
}) => {
  // only ONE `await` allowed in this code
  const locale = (query || {}).locale || 'en';

  let selectedAssetTab = isServer ? req.cookies.defaultAssetTab : readCookie('defaultAssetTab');
  if (selectedAssetTab === 'USDS') selectedAssetTab = 'USDⓈ';

  if (selectedAssetTab)store.dispatch(setSelectedAssetTab(selectedAssetTab));

  // ** End A/B TEST code **

  const shouldPublicAssets = isServer ? req.cookies.shouldPublicAssets : readCookie('shouldPublicAssets');
  store.dispatch(setPublicAssetsStatus(shouldPublicAssets === 'true'));

  let products = [];
  try {
    products = handleGwData(await gwGet(API_PATH.PRODUCTS_API_PATH, null, req));
  } catch (e) {
    // noop
  }

  let recommends = [];
  try {
    recommends = handleGwData(await getRecommendsRequest(locale, req));
  } catch (e) {
    // noop
  }

  const localeData = store.getState().localeData[locale];

  if (!localeData) {
    // 7
    const localeRes = await makeOrCacheApiReq(
      `beta-i18n-${locale}`,
      () => makeApiRequest(I18N_API_PATH(isServer, locale), req, null, null, true)
    );
    store.dispatch(setLocaleData(locale, localeRes));
  }
  if (!store.getState().news[locale]) {
    try {
      const news = await fetchNotice(req, locale);
      store.dispatch(setNewsData(locale, news));
    } catch (e) {
      // noop
    }
  }

  // FETCH in parallel
  if (!products.length !== 0) store.dispatch(setProducts(products));

  // JUST data for this page, not shared
  return {
    metaData: {
      title: metaTitles[locale] || metaTitles.en || `${localeData.Binance || brands[locale]}`,
      keywords: metaKeywords[locale] || metaKeywords.en || '',
      description: metaDescriptions[locale] || metaDescriptions.en || '',
    },
    ServerTime: Date.now(),
    Recommends: recommends,
    wssUri: wssUri(req),
    hostName: getHostName(req),
    isMobile: checkMobile(isServer, req),
  };
};
